export default "__VITE_ASSET__DkQT8CMD__"